var moduleMap = {
	"./chatFlyout": () => {
		return Promise.all([__webpack_require__.e(2020), __webpack_require__.e(1238), __webpack_require__.e(5817), __webpack_require__.e(2281), __webpack_require__.e(921), __webpack_require__.e(5447), __webpack_require__.e(2106), __webpack_require__.e(28), __webpack_require__.e(70), __webpack_require__.e(137), __webpack_require__.e(4651), __webpack_require__.e(2605), __webpack_require__.e(484), __webpack_require__.e(7610)]).then(() => (() => ((__webpack_require__(4934)))));
	},
	"./searchResultGenAI": () => {
		return Promise.all([__webpack_require__.e(2020), __webpack_require__.e(1238), __webpack_require__.e(5817), __webpack_require__.e(2281), __webpack_require__.e(921), __webpack_require__.e(5447), __webpack_require__.e(2106), __webpack_require__.e(28), __webpack_require__.e(70), __webpack_require__.e(137), __webpack_require__.e(4651), __webpack_require__.e(2605), __webpack_require__.e(484), __webpack_require__.e(5679), __webpack_require__.e(2902)]).then(() => (() => ((__webpack_require__(92922)))));
	},
	"./chatContainer": () => {
		return Promise.all([__webpack_require__.e(2020), __webpack_require__.e(1238), __webpack_require__.e(5817), __webpack_require__.e(2281), __webpack_require__.e(921), __webpack_require__.e(5447), __webpack_require__.e(2106), __webpack_require__.e(28), __webpack_require__.e(70), __webpack_require__.e(137), __webpack_require__.e(4651), __webpack_require__.e(2605), __webpack_require__.e(484), __webpack_require__.e(430)]).then(() => (() => ((__webpack_require__(73586)))));
	},
	"./managerAssistantQueryPage": () => {
		return Promise.all([__webpack_require__.e(2020), __webpack_require__.e(1238), __webpack_require__.e(5817), __webpack_require__.e(2281), __webpack_require__.e(921), __webpack_require__.e(5447), __webpack_require__.e(2106), __webpack_require__.e(28), __webpack_require__.e(70), __webpack_require__.e(137), __webpack_require__.e(4651), __webpack_require__.e(2605), __webpack_require__.e(484), __webpack_require__.e(5904), __webpack_require__.e(9175)]).then(() => (() => ((__webpack_require__(75989)))));
	},
	"./app": () => {
		return Promise.all([__webpack_require__.e(2020), __webpack_require__.e(1238), __webpack_require__.e(5817), __webpack_require__.e(2281), __webpack_require__.e(921), __webpack_require__.e(5447), __webpack_require__.e(2106), __webpack_require__.e(28), __webpack_require__.e(70), __webpack_require__.e(137), __webpack_require__.e(4651), __webpack_require__.e(2605), __webpack_require__.e(484), __webpack_require__.e(223)]).then(() => (() => ((__webpack_require__(37197)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});